import React from 'react';
import { PredictedVolumeCapsuleData } from './predictedVolumeCapsuleData';
import {
    DoughnutChart,
    DoughnutChartSeriesItem,
} from 'utils/components/DoughnutChart/DoughnutChart';
import classNames from 'classnames';
import { Tooltip, TooltipText } from '@instinet-analytics/core-lib';
import { usePredictedVolumeCapsuleConfigSlice } from 'widgets/liquiditySummary/predictedVolumeCapsule/state/config/configslice';

export interface PredictedVolumeCapsuleDoughnutProps {
    data: PredictedVolumeCapsuleData;
}

export function PredictedVolumeCapsuleDoughnut(
    props: PredictedVolumeCapsuleDoughnutProps
) {
    const {
        data: {
            labels: {
                predictedRemainingVolume: predictedRemainingVolumeLabel,
                orderLeavesPercent: orderLeavesPercentLabel,
                orderLeaves: orderLeavesLabel,
                predCloseVol: predCloseVolLabel,
                todayVsHist,
            },
            segments,
        },
    } = props;

    const {
        config: { includePredContinuousTrading },
    } = usePredictedVolumeCapsuleConfigSlice();

    const isPredRemainingCaspule = includePredContinuousTrading;

    const showTodayVsHist = isPredRemainingCaspule;
    const showPredictedVolume = isPredRemainingCaspule;
    const showPredictedClose = !isPredRemainingCaspule;
    const showOrderLeaves = true;

    const doughnutData: DoughnutChartSeriesItem[] = segments.map((s) => ({
        id: s.className,
        classname: s.className,
        tooltip: s.tooltip ? { body: s.tooltip } : undefined,
        value: s.value,
        segmentWidth: 12,
    }));

    const tooltip: TooltipText = {
        body: <div>{segments[0].tooltip!}</div>,
    };

    const labelCount =
        (showOrderLeaves ? 1 : 0) +
        (showPredictedClose ? 1 : 0) +
        (showPredictedVolume ? 1 : 0) +
        (showTodayVsHist ? 1 : 0);
    const cssClasses = classNames(
        'PredictedCloseVolumeCapsuleDoughnut',
        `label-count-${labelCount}`
    );

    return (
        <div className={cssClasses}>
            <DoughnutChart doughnutSize={80} data={doughnutData}>
                <div className="percent">
                    <Tooltip text={tooltip}>
                        <div>
                            {predictedRemainingVolumeLabel === ''
                                ? ''
                                : orderLeavesPercentLabel + '%'}
                        </div>
                    </Tooltip>
                </div>
            </DoughnutChart>
            <div className="values">
                {showPredictedVolume && (
                    <div className="avg-close">
                        <div className="expl">Predicted Remaining Volume</div>
                        <div className="value">
                            {predictedRemainingVolumeLabel === ''
                                ? '-'
                                : predictedRemainingVolumeLabel}
                        </div>
                    </div>
                )}
                {showPredictedClose && (
                    <div className="pred-close">
                        <div className="expl">Predicted Closing Auction</div>
                        <div className="value">{predCloseVolLabel}</div>
                    </div>
                )}
                {showTodayVsHist && (
                    <div className="today-vs-hist">
                        <div className="expl">Today vs Hist</div>
                        <div className="value">
                            {todayVsHist === '' ? '-' : todayVsHist + '%'}
                        </div>
                    </div>
                )}
                {showOrderLeaves && (
                    <div className="rem">
                        <div className="expl">Order Leaves</div>
                        <div className="value">{orderLeavesLabel}</div>
                    </div>
                )}
            </div>
        </div>
    );
}
